import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import RebatesExport from '@/components/v2/store_add_ons/RebatesExport';
import ActionButton from '@/components/action_button/Index.vue';
let default_1 = class default_1 extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, AlertMixin) {
    get rebatesExporter() {
        const self = this;
        let rebatesExporterClass = 'rebates-exporter';
        if (self.smOnly) {
            rebatesExporterClass = 'rebates-exporter -sm';
        }
        else if (self.xsOnly) {
            rebatesExporterClass = 'rebates-exporter -xs';
        }
        return rebatesExporterClass;
    }
    alertError(rebates) {
        const self = this;
        if (!rebates || !rebates.length) {
            self.errorNotification('No data to export');
        }
    }
    get labels() {
        const labels = {
            submissionId: 'Submission ID',
            dateOfSubmission: 'Date Of Submission',
            firstName: 'First Name',
            lastName: 'Last Name',
        };
        if (this.rebateStatus === 'approved') {
            Object.assign(labels, {
                dateApproved: 'Date Approved',
                serialId: 'Serial ID / Voucher Code',
                verifiedBy: 'Verified By',
            });
        }
        else if (this.rebateStatus === 'rejected') {
            Object.assign(labels, {
                dateRejected: 'Date Rejected',
                verifiedBy: 'Verified By',
            });
        }
        Object.assign(labels, {
            storeName: 'Store Name',
            amountPurchase: 'Amount of Purchase',
            status: 'Status',
        });
        return labels;
    }
    get fields() {
        return Object.keys(this.labels);
    }
};
__decorate([
    Prop({ type: String, required: true })
], default_1.prototype, "rebateStatus", void 0);
default_1 = __decorate([
    Component({
        components: {
            BaseCsvExporter,
            RebatesExport,
            ActionButton,
        },
    })
], default_1);
export default default_1;
